import BarMenu from "../BarMenu";
import Section from "./Sections";

export default function Profile() {
    return (
        <div id="Profile">
            <BarMenu />
            <section className="profile-section">
                <Section />
            </section>
        </div>
    )
}